module.exports = __webpack_public_path__ + "static/media/view-icon.60b7d69f.svg";